import FbGenericTemplateSetting from "./FbGenericTemplateSetting.vue";
import VarFormSetting from "./VarFormSetting.vue";

export {
    FbGenericTemplateSetting, VarFormSetting
}